import { you } from './PersonaName.locstring.json';
import { observer } from 'mobx-react-lite';
import { isFeatureEnabled } from 'owa-feature-flags';
import loc from 'owa-localize';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import * as React from 'react';
import {
    useLivePersonaCard,
    PersonaCardBehaviorProps,
} from 'owa-persona/lib/components/PersonaCardBehavior';

const styles = require('./Persona.scss');
const classNames = require('classnames');

export default observer(function PersonaName(props: PersonaCardBehaviorProps) {
    const PersonaCardBehavior = useLivePersonaCard({
        ...props,
        className: classNames(styles.persona, props.className),
    });
    const { name, emailAddress } = props;

    return (
        <PersonaCardBehavior>
            <span
                className={classNames(styles.personaName, 'allowTextSelection', {
                    [styles.bold]: !isFeatureEnabled('cal-mf-joinButton'),
                })}>
                {emailAddress === getUserConfiguration().SessionSettings.UserEmailAddress
                    ? loc(you)
                    : name}
            </span>
        </PersonaCardBehavior>
    );
});
